const Usuario = {
	namespaced: true,
	state: {
		usuarioLogado: null,
		carregandoUsuario: false,
		carregouUsuarioComSucesso: false,
	},
	getters: {
		getUsuarioLogado: (state) => (state.usuarioLogado),
		getCarregandoUsuario: (state) => (state.carregandoUsuario),
		getCarregouUsuarioComSucesso: (state) => (state.carregouUsuarioComSucesso),
	},
	mutations: {
		setUsuarioLogado(state, value){
			state.usuarioLogado = value;
		},
		setCarregandoUsuario(state, value){
			state.carregandoUsuario = value;
		},
		setCarregouUsuarioComSucesso(state, value){
			state.carregouUsuarioComSucesso = value;
		},
	},
	actions: {},
};

export default Usuario;
